module.exports = __webpack_public_path__ + "static/banner-8e547ac8bf1ef93500ccad211901bb64.jpg";